export type { UseExpandableContentParams, UseExpandableContentResult } from "./useExpandableContent";
export { useExpandableContent } from "./useExpandableContent";
